import { render, staticRenderFns } from "./panel-shape-settings.vue?vue&type=template&id=f078b854&scoped=true&"
import script from "./panel-shape-settings.vue?vue&type=script&lang=js&"
export * from "./panel-shape-settings.vue?vue&type=script&lang=js&"
import style0 from "./panel-shape-settings.vue?vue&type=style&index=0&id=f078b854&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f078b854",
  null
  
)

export default component.exports